"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setInboxAndSweepRulesService_1 = require("../services/setInboxAndSweepRulesService");
var store_1 = require("../store/store");
var owa_analytics_1 = require("owa-analytics");
var legacy_1 = require("satcheljs/lib/legacy");
var datapoints_1 = require("./datapoints");
/**
 * Saves the current inbox rule configuration
 */
exports.default = legacy_1.select({
    optionState: function () { return store_1.default.inboxRulesListState; },
})(legacy_1.action('setInboxRules', datapoints_1.default.setInboxRulesDatapoint)(function setInboxRules(state) {
    var datapoint = owa_analytics_1.returnTopExecutingActionDatapoint();
    var optionState = state.optionState;
    var inboxRuleIds = optionState.inboxRuleIds;
    var inboxRuleMap = optionState.inboxRules;
    return setInboxAndSweepRulesService_1.default(inboxRuleIds, inboxRuleMap)
        .then(function (response) {
        if (!response.WasSuccessful) {
            var errorMessage = response.ErrorMessage
                ? response.ErrorMessage
                : 'Response WasSuccessful was false';
            datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, new Error(errorMessage));
        }
    })
        .catch(function (error) {
        datapoint.endWithError(owa_analytics_1.DatapointStatus.ServerError, error.message);
    });
}));
//# sourceMappingURL=setInboxRules.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/setInboxRules.js
// module id = 5177
// module chunks = 2